import {FormattedMessage} from "react-intl"
import React from "react"

export default {
	load() {
		return {
			fields: {
				expertiseId: {
					label: <FormattedMessage id="Employee.form.medicalWorkerExpForm.expertise" />,
					rules: "required"
				},
				assesing_physician: {
					label: <FormattedMessage id="Employee.form.medicalWorkerExpForm.assesingPhysician" />
				},
				// expertiseId:{},
				from: {
					label: <FormattedMessage id="Employee.form.medicalWorker.from" />,
					rules: "required",
					type: "date"
				},
				to: {
					label: <FormattedMessage id="Employee.form.medicalWorker.to" />,
					type: "date"
				},
				contract: {
					label: <FormattedMessage id="Employee.form.medicalWorkerExpForm.contract" />
				},
				doctorCode: {
					label: <FormattedMessage id="Employee.form.medicalWorkerExpForm.doctorCode" />
				},
				personnelExpertisesId: {}
			}
		}
	}
}
